const atualizarProtocolosEntrega = (state, protocolosEntrega) => {
    state.protocolosEntrega = protocolosEntrega;
}

const atualizarProtocoloEntrega = (state, protocoloEntrega) => {
    state.protocoloEntrega = protocoloEntrega;
}

const updateProtocoloEntrega = (state, protocoloEntrega) => {
    if (!protocoloEntrega || protocoloEntrega.id == null) return;

    const index = state.protocolosEntrega.findIndex(item => item.id === protocoloEntrega.id);
    if (index >= 0) {
        state.protocolosEntrega.splice(index, 1, JSON.parse(JSON.stringify(protocoloEntrega)));
    }
}

export default {
    atualizarProtocolosEntrega,
    atualizarProtocoloEntrega,
    updateProtocoloEntrega
}
